import { format } from "date-fns";
import { validate, version } from "uuid";
import { ProcessIds } from "@legalzoom/constants";
//#region src/parseOtelAttributes.ts
function parseOtelAttributes(attrString) {
	const attrs = {};
	const keyVals = !!attrString ? attrString.split(",") : [];
	for (const val of keyVals) if (val) {
		const attr = val.split("=");
		if (attr.length) attrs[attr[0]] = attr[1] ?? "";
	}
	return attrs;
}
//#endregion
//#region src/getEnvironment.ts
const isSSR = () => typeof window === "undefined";
const rexConfig = () => ({
	ACTIVITY_FEED_BASE_PATH: process.env.ACTIVITY_FEED_BASE_PATH,
	ADVISOR_AGGREGATE_BASE_PATH: process.env.ADVISOR_AGGREGATE_BASE_PATH,
	ADVISOR_VIEW_BASE_PATH: process.env.ADVISOR_VIEW_BASE_PATH,
	ANCILLARY_API_BASE_PATH: process.env.ANCILLARY_API_BASE_PATH,
	ANCILLARY_API_KEY: process.env.ANCILLARY_API_KEY,
	API_BASE_PATH: process.env.API_BASE_PATH,
	API_BOX_APP_ID: process.env.API_BOX_APP_ID,
	API_KEY: process.env.API_KEY || "",
	AUTH_STATE: process.env.AUTH_STATE,
	AUTHORIZATION_SERVICE_GATEWAY_URL: process.env.AUTHORIZATION_SERVICE_GATEWAY_URL,
	AUTHORIZATION_SERVICE_URL: process.env.AUTHORIZATION_SERVICE_URL,
	ACCOUNT_TOOLS_CLIENT_ID: process.env.ACCOUNT_TOOLS_CLIENT_ID,
	ACCOUNT_TOOLS_SECRET: process.env.ACCOUNT_TOOLS_SECRET,
	COMPLIANCE_HEALTH_SCAN_CLIENT_ID: process.env.COMPLIANCE_HEALTH_SCAN_CLIENT_ID,
	COMPLIANCE_HEALTH_SCAN_SECRET: process.env.COMPLIANCE_HEALTH_SCAN_SECRET,
	SALESFORCE_CLIENT_ID: process.env.SALESFORCE_CLIENT_ID,
	SALESFORCE_SECRET: process.env.SALESFORCE_SECRET,
	SALESFORCE_BASE_PATH: process.env.SALESFORCE_BASE_PATH,
	BASE_URL: process.env.BASE_URL,
	BUSINESS_LICENSES_BASE_PATH: process.env.BUSINESS_LICENSES_BASE_PATH,
	BUSINESS_PROFILE_PLATFORM: process.env.BUSINESS_PROFILE_PLATFORM,
	CHECKOUT_GRAPHQL_PATH: process.env.CHECKOUT_GRAPHQL_PATH,
	CONSULTATION_API_BASE_PATH: process.env.CONSULTATION_API_BASE_PATH,
	CLIENT_ID: process.env.CLIENT_ID,
	CREATE_ACCOUNT_PASSWORD: process.env.CREATE_ACCOUNT_PASSWORD,
	CSP_CONNECT_SRC: process.env.CSP_CONNECT_SRC,
	CSP_DEFAULT_SRC: process.env.CSP_DEFAULT_SRC,
	CSP_FONT_SRC: process.env.CSP_FONT_SRC,
	CSP_FORM_ACTION: process.env.CSP_FORM_ACTION,
	CSP_FRAME_SRC: process.env.CSP_FRAME_SRC,
	CSP_IMG_SRC: process.env.CSP_IMG_SRC,
	CSP_WORKER_SRC: process.env.CSP_WORKER_SRC,
	CSP_MEDIA_SRC: process.env.CSP_MEDIA_SRC,
	CSP_SCRIPT_SRC: process.env.CSP_SCRIPT_SRC,
	CSP_SCRIPT_SRC_ATTR: process.env.CSP_SCRIPT_SRC_ATTR,
	CSP_SCRIPT_SRC_ELEM: process.env.CSP_SCRIPT_SRC_ELEM,
	CUSTOMER_BASE_PATH: process.env.CUSTOMER_BASE_PATH,
	DATADOG_ENV: parseOtelAttributes(process.env.OTEL_RESOURCE_ATTRIBUTES ?? "")["deployment.environment"] || process.env.ENV?.[0],
	DATADOG_APP_ID: process.env.DATADOG_APP_ID,
	DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
	DESIGN_API_KEY: process.env.DESIGN_API_KEY,
	PUBLIC_VIRTUAL_MAIL_GOOGLE_MAPS_KEY: process.env.PUBLIC_VIRTUAL_MAIL_GOOGLE_MAPS_KEY,
	ECM_STRIPE_CLIENT_KEY: process.env.ECM_STRIPE_CLIENT_KEY,
	ECP_BASE_PATH: process.env.ECP_BASE_PATH,
	ENV: process.env.ENV,
	ENABLE_CSP: process.env.ENABLE_CSP,
	ENABLE_CSP_ENFORCEMENT: process.env.ENABLE_CSP_ENFORCEMENT,
	ENTITLEMENTS_PLATFORM: process.env.ENTITLEMENTS_PLATFORM,
	ESIGNATURE_PRICING_YAML: process.env.ESIGNATURE_PRICING_YAML,
	ESIGNATURE_PRICING_YAML_OLD: process.env.ESIGNATURE_PRICING_YAML_OLD,
	FULFILLMENT_BASE_PATH: process.env.FULFILLMENT_BASE_PATH,
	FORM_BAP_PRICING_YAML_NEW: process.env.FORM_BAP_PRICING_YAML_NEW,
	FORMATIONS_BASE_PATH: process.env.FORMATIONS_BASE_PATH,
	FORMS_ESIGN_ANNUALLY_OFFER_ID: process.env.FORMS_ESIGN_ANNUALLY_OFFER_ID,
	FORMS_ESIGN_SINGLE_DOCUMENT_OFFER_ID: process.env.FORMS_ESIGN_SINGLE_DOCUMENT_OFFER_ID,
	GRAPHQL_PATH: process.env.GRAPHQL_PATH,
	GRAPHQL_PATH_INTERNAL: process.env.GRAPHQL_PATH_INTERNAL,
	IDENTITY_PROTECTION_BASE_PATH: process.env.IDENTITY_PROTECTION_BASE_PATH,
	INTELLECTUAL_PROPERTY_BASE_PATH: process.env.INTELLECTUAL_PROPERTY_BASE_PATH,
	INTERCOM_APP_ID: process.env.INTERCOM_APP_ID,
	INTERCOM_VERIFICATION_SECRET: process.env.INTERCOM_VERIFICATION_SECRET,
	IOS_CLIENT_ID: process.env.IOS_CLIENT_ID,
	IP_API_BASE_PATH: process.env.IP_API_BASE_PATH,
	LAUNCH_DARKLY_SDK_KEY: process.env.LAUNCH_DARKLY_SDK_KEY,
	LEGAL_AGREEMENT_BASE_PATH: process.env.LEGAL_AGREEMENT_BASE_PATH,
	LZ_AUTH_SERVER: process.env.LZ_AUTH_SERVER,
	LZ_PROXY_URL: process.env.LZ_PROXY_URL,
	MOONWALK_BASE_PATH: process.env.MOONWALK_BASE_PATH,
	MOONWALK_GOOGLE_CLIENT_KEY: process.env.MOONWALK_GOOGLE_CLIENT_KEY,
	MOONWALK_STRIPE_CLIENT_KEY: process.env.MOONWALK_STRIPE_CLIENT_KEY,
	MOONWALK_TAX_START_BUFFER_DAYS: process.env.MOONWALK_TAX_START_BUFFER_DAYS,
	NEXT_SDK_DATA_ENV: process.env.NEXT_SDK_DATA_ENV,
	NEXT_SDK_URL: process.env.NEXT_SDK_URL,
	ONE_EIGHT_HUNDRED_SCHEDULE_URL: process.env.ONE_EIGHT_HUNDRED_SCHEDULE_URL,
	ONETRUST_CONSENT_SYNC_KEY: process.env.ONETRUST_CONSENT_SYNC_KEY,
	ORDER_BASE_PATH: process.env.ORDER_BASE_PATH,
	PROCESSING_ORDER_BASE_PATH: process.env.PROCESSING_ORDER_BASE_PATH,
	OT_DOMAIN_SCRIPT_KEY: process.env.OT_DOMAIN_SCRIPT_KEY,
	PRODUCT_BASE_PATH: process.env.PRODUCT_BASE_PATH,
	PUBLIC_PATH: process.env.PUBLIC_PATH,
	PUBLIC_TRUSTPILOT_API_KEY: process.env.PUBLIC_TRUSTPILOT_API_KEY,
	QUESTIONNAIRE_ANSWER_BASE_PATH: process.env.QUESTIONNAIRE_ANSWER_BASE_PATH,
	QUESTIONNAIRE_STORAGE_BASE_PATH: process.env.QUESTIONNAIRE_STORAGE_BASE_PATH,
	RECAPTCHA_V3_KEY: process.env.RECAPTCHA_V3_KEY,
	REDIS_CONNECTION: process.env.REDIS_CONNECTION,
	COMMERCE_SUBSCRIPTIONS_CACHE_TTL_SECONDS: process.env.COMMERCE_SUBSCRIPTIONS_CACHE_TTL_SECONDS,
	RELATIONSHIP_BASE_PATH: process.env.RELATIONSHIP_BASE_PATH,
	REMIX_COOKIE_SIGNING_SECRET: process.env.REMIX_COOKIE_SIGNING_SECRET,
	REVV_API_BASE_PATH: process.env.REVV_API_BASE_PATH,
	REVV_STRIPE_API_KEY: process.env.REVV_STRIPE_API_KEY,
	LIBRE_LAMBDA_PATH: process.env.LIBRE_LAMBDA_PATH,
	SEGMENT_SERVER_WRITE_KEY: process.env.SEGMENT_SERVER_WRITE_KEY,
	SEGMENT_WRITE_KEY: process.env.SEGMENT_WRITE_KEY,
	SENTRY_PROJECT_LINK: process.env.SENTRY_PROJECT_LINK,
	SLACK_ANCILLARY_SKU_SERVICE_ALERTS_URL: process.env.SLACK_ANCILLARY_SKU_SERVICE_ALERTS_URL,
	SSO_PROXY_BASE_PATH: process.env.SSO_PROXY_BASE_PATH,
	STATE_ENCRYPT_KEY: process.env.STATE_ENCRYPT_KEY,
	STATE_INIT_VECTOR: process.env.STATE_INIT_VECTOR,
	STORAGE_BROWSER_CLIENT_PATH: process.env.STORAGE_BROWSER_CLIENT_PATH,
	STORAGE_SERVICE_END_POINT: process.env.STORAGE_SERVICE_END_POINT,
	STRIPE_CLIENT_KEY: process.env.STRIPE_CLIENT_KEY,
	SUBSCRIPTION_BASE_PATH: process.env.SUBSCRIPTION_BASE_PATH,
	TASK_SERVICE_PATH: process.env.TASK_SERVICE_PATH,
	TEALIUM_CONFIG_ENVIRONMENT: process.env.TEALIUM_CONFIG_ENVIRONMENT,
	TIME_WARP_GRAPHQL_PATH: process.env.LOCAL_TIME_WARP_GRAPHQL_PATH ?? process.env.TIME_WARP_GRAPHQL_PATH,
	CHARGEBEE_SITE: process.env.CHARGEBEE_SITE,
	CHARGEBEE_PUBLISHABLE_KEY: process.env.CHARGEBEE_PUBLISHABLE_KEY,
	TOKEN_API_PATH: process.env.TOKEN_API_PATH,
	WEB_SESSION_API_BASE_PATH: process.env.WEB_SESSION_API_BASE_PATH,
	OTEL_RESOURCE_ATTRIBUTES: process.env.OTEL_RESOURCE_ATTRIBUTES,
	GIT_COMMIT: process.env.GIT_COMMIT ?? "",
	FORM_BAP_PRICING_YAML: process.env.FORM_BAP_PRICING_YAML,
	BILLING_BASE_PATH: process.env.BILLING_BASE_PATH,
	SINGLE_DOC_ESIGN_OFFER_ID: process.env.SINGLE_DOC_ESIGN_OFFER_ID,
	MONTHLY_ESIGN_OFFER_ID: process.env.MONTHLY_ESIGN_OFFER_ID,
	ANNUAL_ESIGN_OFFER_ID: process.env.ANNUAL_ESIGN_OFFER_ID,
	MONTHLY_ESIGN_OFFER_NEW_ID: process.env.MONTHLY_ESIGN_OFFER_NEW_ID,
	ANNUAL_ESIGN_OFFER_NEW_ID: process.env.ANNUAL_ESIGN_OFFER_NEW_ID,
	TIME_TAP_URL: process.env.TIME_TAP_URL,
	GRAPHQL_ECM_PATH: process.env.GRAPHQL_ECM_PATH,
	CREATE_ACCOUNT_SLACK_BOT_TOKEN: process.env.CREATE_ACCOUNT_SLACK_BOT_TOKEN,
	CREATE_ACCOUNT_SLACK_VERIFICATION_TOKEN: process.env.CREATE_ACCOUNT_SLACK_VERIFICATION_TOKEN,
	STRIPE_ACCOUNT_DETAILS_FLOW_ID: process.env.STRIPE_ACCOUNT_DETAILS_FLOW_ID,
	NAME_CHANGE_TIME_TAP_URL: process.env.NAME_CHANGE_TIME_TAP_URL,
	PERSONAL_SERVICES_GRAPHQL_PATH: process.env.PERSONAL_SERVICES_GRAPHQL_PATH,
	ADDRESS_VALIDATION_API_BASE_PATH: process.env.ADDRESS_VALIDATION_API_BASE_PATH,
	TEMPLATE_STORE_ASSETS_BASE_URL: process.env.TEMPLATE_STORE_ASSETS_BASE_URL,
	AI_ASSISTANT_BASE_PATH: process.env.AI_ASSISTANT_BASE_PATH,
	WEB_SESSION_API_GW_BASE_PATH: process.env.WEB_SESSION_API_GW_BASE_PATH,
	DRUPAL_BASE_PATH: process.env.DRUPAL_BASE_PATH,
	PS_CHECKOUT_SERVICES_GRAPHQL_PATH: process.env.PS_CHECKOUT_SERVICES_GRAPHQL_PATH,
	PARTNERSHIPS_INBOUND_BASE_PATH: process.env.PARTNERSHIPS_INBOUND_BASE_PATH,
	SESSION_SERVICE_PATH: process.env.SESSION_SERVICE_PATH,
	REQUEST_TIMEOUT: process.env.REQUEST_TIMEOUT,
	NON_RETRY_ERROR_CODES: process.env.NON_RETRY_ERROR_CODES,
	AFK_TIME: process.env.AFK_TIME,
	SESSION_NOTIFICATION_TIME_THRESHOLD: process.env.SESSION_NOTIFICATION_TIME_THRESHOLD,
	MFA_EXCLUDED_DIAL_CODES: process.env.MFA_EXCLUDED_DIAL_CODES,
	AWS_REGION: process.env.AWS_REGION,
	TAGGING_SERVICE_BASE_URL: process.env.TAGGING_SERVICE_BASE_URL,
	TEST_AUTOMATION_CLIENT: process.env.TEST_AUTOMATION_CLIENT,
	TEST_AUTOMATION_SECRET: process.env.TEST_AUTOMATION_SECRET,
	MODEL_HUB_LLM_BASE_PATH: process.env.MODEL_HUB_LLM_BASE_PATH,
	MODEL_HUB_KB_ID: process.env.MODEL_HUB_KB_ID,
	UACH_WEBCHAT_BASE_URL: process.env.UACH_WEBCHAT_BASE_URL,
	UNIVERSAL_CHECKOUT_CLIENT_ID: process.env.UNIVERSAL_CHECKOUT_CLIENT_ID,
	UNIVERSAL_CHECKOUT_CLIENT_SECRET: process.env.UNIVERSAL_CHECKOUT_CLIENT_SECRET,
	COMPLIANCE_MOM_OPENAI_API_KEY: process.env.COMPLIANCE_MOM_OPENAI_API_KEY
});
const getEnvironment = () => {
	const isTest = process.env.NODE_ENV === "test";
	const config = isSSR() || isTest ? rexConfig() : window.ENV;
	if (!config) console.warn("Unable to load environment variables");
	return config || {};
};
//#endregion
//#region src/sanitizePhoneNumber.ts
/**
* +55555555555 => 5555555555 (intl phone numbers)
* 55555555555  => 15555555555 (us phone numbers)
*
* Currently only used by MFA Modal
*/
const sanitizePhoneNumber = (enteredPhoneNumber) => {
	if (enteredPhoneNumber.startsWith("+")) return enteredPhoneNumber.slice(1);
	return `1${enteredPhoneNumber}` || "";
};
//#endregion
//#region src/inject-script.ts
function injectScript({ src, text, async = false, callback, onCleanup, attributes }) {
	const script = document.createElement("script");
	script.type = "text/javascript";
	if (src) script.src = src;
	else if (text) script.text = text;
	if (callback) script.addEventListener("load", callback);
	if (attributes) Object.entries(attributes).forEach(([key, value]) => {
		script.setAttribute(key, value);
	});
	script.async = async;
	document.head.appendChild(script);
	return () => {
		if (callback) script.removeEventListener("load", callback);
		onCleanup?.();
		if (script.parentNode === document.head) document.head.removeChild(script);
	};
}
//#endregion
//#region src/is-external-link.ts
var is_external_link_default = (route) => !route.match(/^\/my([^\w]|$)/i);
//#endregion
//#region src/is-deployment-preview-url.ts
/**
* https://rex-preview-prd.my-account-rex.apps.prd.aws-01.legalzoom.com
* https://rex-preview-dev.my-account-rex.dev.aws-01.legalzoom.com
* https://rex-preview-qa.my-account-rex.dev.aws-01.legalzoom.com
* https://rex-preview-canary.my-account-rex.dev.aws-01.legalzoom.com
*/
var is_deployment_preview_url_default = (route) => !!route.match(/^(?:https?:\/\/)?(rex-preview-(prd|qa|dev|canary))\.my-account-rex\.(apps\.prd\.aws-01\.legalzoom\.com|dev\.aws-01\.legalzoom\.com)/i);
//#endregion
//#region src/is-ephemeral.ts
var is_ephemeral_default = (route) => !!route.match(/^(?:https?:\/\/)?pr\d+\.my-account-rex\.dev\.aws-01\.legalzoom\.com/i);
//#endregion
//#region src/is-samba-url.ts
var is_samba_url_default = (route) => !!route.match(/^(?:https?:\/\/)?[\w-]+\.samba\.legalzoom\.com/i);
//#endregion
//#region src/is-legal-zoom-url.ts
var is_legal_zoom_url_default = (url) => !!url.match(/^https?:\/\/www(?:local|dev|qa)?\.legalzoom.com/i) || is_ephemeral_default(url) || is_deployment_preview_url_default(url) || is_samba_url_default(url);
//#endregion
//#region src/is-valid-url.ts
var is_valid_url_default = (url) => {
	try {
		return Boolean(new URL(url));
	} catch (e) {
		return false;
	}
};
//#endregion
//#region src/is-internal-url.ts
var is_internal_url_default = (url, internalRoute) => {
	const isInternalRoute = typeof internalRoute === "string" ? (to) => to.startsWith(internalRoute.replace(/\/$/, "")) : internalRoute;
	if (is_valid_url_default(url)) {
		const { pathname } = new URL(url);
		return is_legal_zoom_url_default(url) ? isInternalRoute(pathname.replace(/\/$/, "")) : false;
	}
	return isInternalRoute(url);
};
//#endregion
//#region src/isEmpty.ts
const isEmpty = (value) => {
	if (value == null || value.length === 0) return true;
	return false;
};
//#endregion
//#region src/stripCharacters.ts
const specialCharacters = [
	"\\",
	"/",
	"[",
	"]",
	"(",
	")",
	"{",
	"}",
	"^",
	"$",
	".",
	"*",
	"+",
	"?",
	"|"
];
function stripCharacters(input, ...characters) {
	const escapedCharacters = characters.map((c) => specialCharacters.includes(c) ? `\\${c}` : c);
	return input.replace(new RegExp(`[${escapedCharacters.join("")}]`, "g"), "");
}
//#endregion
//#region src/creditCardUtils.ts
const isMasked = (ccNumber) => /^\*{11,12}\d/.test(ccNumber);
const passesLuhnAlgorithm = (ccNumber) => {
	let checkDouble = false;
	let sum = 0;
	const valueMapWhenCheckDouble = [
		0,
		2,
		4,
		6,
		8,
		1,
		3,
		5,
		7,
		9
	];
	for (let n = ccNumber.length; n > 0; n--) {
		const digit = parseInt(ccNumber.charAt(n - 1), 10);
		sum += checkDouble ? valueMapWhenCheckDouble[digit] : digit;
		checkDouble = !checkDouble;
	}
	return sum !== 0 && sum % 10 === 0;
};
var CreditCardUtils = class {
	static parseCreditCardNumber(value) {
		const cleaned = value.replace(/ /g, "").replace(/_/g, "");
		if (cleaned.length < 12) throw new Error("Invalid credit card number");
		return cleaned;
	}
	static parseExpirationMonth(value) {
		const cleaned = value.replace(/_/g, "");
		if (cleaned.length < 2) throw new Error("Invalid expiration month");
		return parseInt(cleaned, 10);
	}
	static extractMonthAndYear(date) {
		const parts = date.split("/");
		if (parts.length !== 2) return [null, null];
		return [parts[0].indexOf("_") !== -1 ? null : parseInt(parts[0], 10), parts[1].indexOf("_") !== -1 ? null : parseInt(parts[1], 10)];
	}
	static isValidNumber(value) {
		if (isEmpty(value)) return false;
		try {
			const parsed = parseInt(value, 10);
			if (Number.isNaN(parsed)) return false;
		} catch (e) {
			return false;
		}
		return true;
	}
	static isValidCVV(value, amex = false) {
		if (isEmpty(value)) return false;
		const limit = amex ? 4 : 3;
		const cleaned = value.replace(/_/g, "");
		if (cleaned.length !== limit) return false;
		return this.isValidNumber(cleaned);
	}
	static isValidZipCode(value) {
		if (isEmpty(value)) return false;
		return /^\d{5}(?:-\d{4})?$/.test(value);
	}
	static isValidCreditCardLuhnAlgorithm(ccNumber) {
		if (typeof ccNumber !== "string") throw new TypeError("Expected string input");
		const trimmedCcNumber = ccNumber.replace(/[\s]/g, "");
		if (!trimmedCcNumber) return false;
		if (isMasked(trimmedCcNumber)) return true;
		if (!/^[0-9]+$/.test(trimmedCcNumber)) return false;
		return passesLuhnAlgorithm(trimmedCcNumber);
	}
	static isValidExpirationDate(value) {
		const monthRegex = /(0[1-9]|1[0-2])/;
		const rawExpiryDate = value.replace("/", "");
		if (rawExpiryDate.length === 4) {
			const month = rawExpiryDate.slice(0, 2);
			const year = `20${rawExpiryDate.slice(2)}`;
			if (!monthRegex.test(month)) return false;
			if (parseInt(year, 10) < (/* @__PURE__ */ new Date()).getFullYear()) return false;
			if (parseInt(year, 10) === (/* @__PURE__ */ new Date()).getFullYear() && parseInt(month, 10) < (/* @__PURE__ */ new Date()).getMonth() + 1) return false;
			return true;
		}
		return false;
	}
	static stripCCMask(value) {
		return stripCharacters(value, "-", "_");
	}
	static stripExpirationDateMask(value) {
		return stripCharacters(value, "EXP ", "_");
	}
	static stripCVVMask(value) {
		return stripCharacters(value, "CVV ", "_");
	}
	static stripZipCodeMask(value) {
		return stripCharacters(value, "_");
	}
};
//#endregion
//#region src/isLZFormationAccount.ts
const isLZFormationAccount = (workspaceIds) => !!workspaceIds.processingOrderId;
//#endregion
//#region src/isNonLZFormationAccount.ts
const isNonLZFormationAccount = (workspaceIds) => !workspaceIds.processingOrderId;
//#endregion
//#region src/isTouchDevice.ts
var isTouchDevice_default = () => typeof window === "undefined" ? false : "ontouchstart" in window || navigator.maxTouchPoints > 0;
//#endregion
//#region src/getGenericTimezone.ts
function getGenericTimezone(timezone) {
	switch (timezone) {
		case "AKST":
		case "AKDT": return "AK";
		case "CST":
		case "CDT": return "CT";
		case "EST":
		case "EDT": return "ET";
		case "HST":
		case "HDT": return "HI";
		case "MST":
		case "MDT": return "MT";
		case "PST":
		case "PDT": return "PT";
		default: return timezone;
	}
}
//#endregion
//#region src/isValidName.ts
const isValidName = (name) => /^[a-zA-Z,.'-]+(\s[a-zA-Z,.'-]+)*$/.test(name);
//#endregion
//#region src/formatPhoneNumber.ts
/** formatPhoneNumber
* Formats a phone number with the given syntax "(XXX) XXX-XXXX"
* @param {String} unformatedPhoneNumber
* @returns {String}
*/
const formatPhoneNumber = (phoneNumber) => {
	const match = `${phoneNumber}`.replace(/\D/g, "").slice(-10).match(/^(\d{3})(\d{3})(\d{4})$/);
	if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
	return "";
};
/**
* Masks a phone number, showing only the last four digits
* @param phoneNumber - The phone number to mask.
* @returns The masked phone number.
*/
const maskedPhoneNumber = (phoneNumber) => {
	return `(XXX) XXX-${phoneNumber.slice(phoneNumber.length - 4)}`;
};
//#endregion
//#region src/formatCurrency.ts
const formatCurrency = ({ amount = 0, digits = 2, replaceZeroes = false }) => {
	const formattedCurrency = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: digits
	}).format(amount);
	return replaceZeroes ? formattedCurrency.replace(/\.00$/, "") : formattedCurrency;
};
//#endregion
//#region src/clamp.ts
const clamp = (value, min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY) => Math.min(Math.max(value, min), max);
//#endregion
//#region src/is-browser-safari.ts
function isBrowserSafari() {
	const { userAgent } = window.navigator;
	const safari = userAgent.indexOf("Safari") !== -1;
	const chrome = userAgent.indexOf("Chrome") !== -1;
	return safari && !chrome;
}
//#endregion
//#region src/isValidDate.ts
/**
* Determines if the supplied date is a valid date, inclusive of leap years
* @param dateString in the format of MM/DD/YYYY
* @param allowFutureDates
* @returns
*/
const isValidDate = (dateString, allowFutureDates = false) => {
	if (!dateString) return false;
	const month = dateString.split("/")[0];
	const date = new Date(dateString);
	return !Number.isNaN(date.getTime()) && date.getMonth() === parseInt(month, 10) - 1 && (!(date > /* @__PURE__ */ new Date()) || allowFutureDates);
};
//#endregion
//#region src/formatDateString.ts
const formatDateString = (dateString) => {
	if (!dateString) return void 0;
	const [year, month, day] = dateString.split(/[T-]/).map((token) => Number(token));
	return new Date(year, month - 1, day).toLocaleDateString("default", {
		month: "long",
		day: "numeric",
		year: "numeric"
	});
};
//#endregion
//#region src/formatDate.ts
/**
* Take a UTC Date and the local timezone offset
*/
const getDateWithTimezoneOffset = (date) => new Date(new Date(date).valueOf() + new Date(date).getTimezoneOffset() * 60 * 1e3);
/**
* Formats date and localize timezone if time is available
*/
const formatDate = (date = "", outputFormat = "MMMM d, yyyy") => {
	if (date instanceof Date) return format(date, outputFormat);
	if (Number.isNaN(Date.parse(date))) return "";
	if (/:/.test(date)) return format(new Date(date), outputFormat);
	return format(getDateWithTimezoneOffset(date), outputFormat);
};
//#endregion
//#region src/is-cp2-order-id.ts
const isCp2OrderId = (orderId) => {
	if (typeof orderId === "number" || !orderId) return false;
	return /^R-\d{4}-\d{4}-\d{4}$/.test(orderId);
};
//#endregion
//#region src/snakeToCamelCase.ts
const snakeToCamelCase = (str) => str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
//#endregion
//#region src/isCustomerTestAccount.ts
const testAccountDomains = [
	"legalzoom.com",
	"legalzoomqaindia.com",
	"lz.com",
	"revvsales.com",
	"austinmonks.com",
	"revv.com"
];
const isCustomerTestAccount = (email) => {
	if (email) return testAccountDomains.includes(email.split("@")[1]);
	return false;
};
//#endregion
//#region src/isValidAccountIdString.ts
const isValidAccountIdString = (string) => {
	return string && validate(string) && version(string) === 4;
};
//#endregion
//#region src/dd-trace.ts
const UINT_MAX = 4294967296;
const readInt32 = (buffer, offset) => buffer[offset + 0] * 16777216 + (buffer[offset + 1] << 16) + (buffer[offset + 2] << 8) + buffer[offset + 3];
const toNumberString = (buffer, radix) => {
	let high = readInt32(buffer, 0);
	let low = readInt32(buffer, 4);
	let str = "";
	radix = radix || 10;
	do {
		const mod = high % radix * UINT_MAX + low;
		high = Math.floor(high / radix);
		low = Math.floor(mod / radix);
		str = (mod % radix).toString(radix) + str;
	} while (high || low);
	return str;
};
const writeUInt32BE = (buffer, value, offset) => {
	buffer[3 + offset] = value & 255;
	value >>= 8;
	buffer[2 + offset] = value & 255;
	value >>= 8;
	buffer[1 + offset] = value & 255;
	value >>= 8;
	buffer[0 + offset] = value & 255;
};
const fromString = (str, raddix) => {
	const buffer = new Uint8Array(8);
	const len = str.length;
	let pos = 0;
	let high = 0;
	let low = 0;
	if (str[0] === "-") pos++;
	const sign = pos;
	while (pos < len) {
		const chr = parseInt(str[pos++], raddix);
		if (!(chr >= 0)) break;
		low = low * raddix + chr;
		high = high * raddix + Math.floor(low / UINT_MAX);
		low %= UINT_MAX;
	}
	if (sign) {
		high = ~high;
		if (low) low = UINT_MAX - low;
		else high++;
	}
	writeUInt32BE(buffer, high, 0);
	writeUInt32BE(buffer, low, 4);
	return buffer;
};
const toDatadogSpanId = (spanId) => {
	if (!spanId) return;
	return toNumberString(fromString(spanId, 16));
};
const toDatadogTraceId = (traceId) => {
	if (!traceId) return;
	return toNumberString(fromString(traceId.slice(traceId.length / 2), 16));
};
/**
* resolve the absolute url at the current public server url
* @param relativeUrl
* @returns
*/
const resolveUrl = (relativeUrl = "", ...search) => {
	const { BASE_URL } = getEnvironment() || {};
	const base = BASE_URL || "https://www.legalzoom.com";
	const req = relativeUrl ? new URL(relativeUrl, base) : new URL(base);
	search.forEach(([name, value]) => {
		req.searchParams.append(name, value);
	});
	const url = new URL(`${base}${req.search}`);
	if (req.pathname) url.pathname = req.pathname;
	return url.href.substr(-1) === "/" ? url.href.substr(0, url.href.length - 1) : url.href;
};
//#endregion
//#region src/redirect.ts
const mergeQueryStrings = (qs1, qs2) => {
	const params1 = new URLSearchParams(qs1);
	new URLSearchParams(qs2).forEach((val, key) => {
		if (!params1.has(key)) params1.append(key, val);
	});
	return params1.size ? `?${params1.toString()}` : "";
};
const withHttps = (url) => !/^https?:\/\//i.test(url) ? `https://${url}` : url;
/**
* redirect with environment specific logic and url resolution
* @param url
* @param param1
* @returns
*/
const redirect = (url = "", { status = 302, headers = {}, external = false, request } = {}) => {
	let finalHeaders;
	/**
	* https://github.com/remix-run/remix/issues/231
	* Encountered a bug when clearing cookies after signing out. When "Set-Cookie" sends back all
	* the cookies to set in one header, the browser does not clear the cookie. This seems to be
	* happening when "headers" are set as Record<string, string>, but sending an instance of the
	* Headers class works as expected.
	*/
	if (headers instanceof Headers) finalHeaders = headers;
	else {
		finalHeaders = new Headers();
		Object.entries(headers).forEach(([key, value]) => {
			finalHeaders.append(key, value);
		});
	}
	const host = request?.headers.get("host");
	if (host && (is_ephemeral_default(host) || is_deployment_preview_url_default(host) || is_samba_url_default(host)) && !external) {
		external = true;
		url = new URL(url, withHttps(host)).href;
	}
	if (request && host) url = url.split("?")[0] + mergeQueryStrings(new URL(url, withHttps(host)).search, new URL(request.url, withHttps(host)).search);
	finalHeaders.append("Location", external ? url : resolveUrl(url));
	return new Response(null, {
		status,
		headers: finalHeaders
	});
};
//#endregion
//#region src/getTrackingProcessId.ts
function getTrackingProcessId(source) {
	let output = "";
	if (source) output = ProcessIds[source].replace(/([A-Z]+|[0-9]+)/g, " $1").replace(/(_)/g, "").toLowerCase().trim();
	return output;
}
//#endregion
//#region src/url-utils.ts
/**
* @param url The url to extract search params from
* @param prefixes The prefix to use when  filtering the search params
* @returns An object containing the search params that matched the prefix along with their values
*/
function getSearchParamsWithPrefix(url, prefixes) {
	if (!prefixes || !prefixes.length) throw new Error("Prefix must be provided");
	const prefixList = typeof prefixes === "string" ? [prefixes] : [...prefixes];
	return Object.entries(Object.fromEntries(new URL(url).searchParams)).reduce((aggregate, [key, value]) => {
		if (prefixList.some((prefix) => key.startsWith(prefix))) aggregate[key] = value;
		return aggregate;
	}, {});
}
function getPublicUrl(url, env, cleanQS) {
	const { BASE_URL } = env;
	const baseUrl = new URL(BASE_URL || "https://www.legalzoom.com");
	const output = new URL(url);
	output.protocol = baseUrl.protocol;
	if (output.host.includes("cloudfront")) output.host = baseUrl.host;
	if (cleanQS) output.searchParams.delete("_data");
	return output.href;
}
function isRelativeUrl(url) {
	return url.indexOf("://") === -1 && url.indexOf("//") !== 0;
}
//#endregion
//#region src/section-team-mapping.ts
/**
* Maps URL path segments to page sections and owning teams.
* Used by both client-side RUM and server-side span tagging.
*/
function getPageSection(path) {
	try {
		const accountMatch = path.match(/^\/my\/account\/[^/]+\/([^/]+)/);
		if (accountMatch) return accountMatch[1];
		if (/^\/my\/account\/[^/]+\/?$/.test(path)) return "home";
		const topLevelMatch = path.match(/^\/my\/([^/]+)/);
		if (topLevelMatch) return topLevelMatch[1];
		return null;
	} catch {
		return null;
	}
}
const SECTION_TO_TEAM = {
	home: "squad-mylz-home",
	compliance: "squad-mylz-home",
	"account-profile": "squad-mylz-home",
	"account-tools": "squad-mylz-home",
	"business-onboarding": "squad-mylz-home",
	onboarding: "squad-mylz-home",
	"create-account": "squad-mylz-home",
	"account-settings": "squad-mylz-home",
	books: "squad-books",
	login: "squad-identity",
	legal: "squad-experts-platform",
	consultation: "squad-experts-platform",
	"schedule-consultations": "squad-experts-platform",
	"payment-history": "squad-commerce",
	checkout: "squad-commerce",
	subscriptions: "squad-commerce",
	payments: "squad-commerce",
	trademark: "squad-altm-ip",
	patent: "squad-altm-ip",
	partnerships: "squad-partnerships",
	"business-toolkit": "squad-partnerships",
	"document-editor": "squad-estateplanning",
	"forms-builder": "squad-estateplanning",
	"assets-manager": "squad-estateplanning",
	"compliance-health-scan": "squad-estateplanning",
	documents: "squad-estateplanning",
	tax: "squad-estateplanning",
	"virtual-mail": "squad-virtual-mail"
};
function getTeamForSection(section) {
	return SECTION_TO_TEAM[section] ?? null;
}
//#endregion
//#region src/rate-limiter.server.ts
const ipRequests = /* @__PURE__ */ new Map();
const DEFAULT_TIME_WINDOW = 500;
function isRateLimited(ip, options) {
	const { requestLimit, timeWindow = DEFAULT_TIME_WINDOW } = options;
	const currentTime = Date.now();
	const entry = ipRequests.get(ip);
	if (entry && entry.expiresAt > currentTime) {
		if (entry.count >= entry.requestLimit) return true;
		entry.count++;
	} else ipRequests.set(ip, {
		count: 1,
		expiresAt: currentTime + timeWindow,
		requestLimit
	});
	return false;
}
function getClientIp(headers) {
	const extractIp = (headerValue) => headerValue ? headerValue.split(",")[0].trim() : null;
	const ip = extractIp(headers.get("x-forwarded-for")) || headers.get("x-real-ip");
	if (ip) return ip;
	if (process.env.NODE_ENV === "development") return "127.0.0.1";
	return "0.0.0.0";
}
//#endregion
export { CreditCardUtils, SECTION_TO_TEAM, clamp, formatCurrency, formatDate, formatDateString, formatPhoneNumber, getClientIp, getDateWithTimezoneOffset, getEnvironment, getGenericTimezone, getPageSection, getPublicUrl, getSearchParamsWithPrefix, getTeamForSection, getTrackingProcessId, injectScript, isBrowserSafari, isCp2OrderId, isCustomerTestAccount, isEmpty, is_ephemeral_default as isEphemeral, is_external_link_default as isExternalLink, is_internal_url_default as isInternalUrl, isLZFormationAccount, is_legal_zoom_url_default as isLegalZoomUrl, isNonLZFormationAccount, isRateLimited, isRelativeUrl, is_samba_url_default as isSambaUrl, isTouchDevice_default as isTouchDevice, isValidAccountIdString, isValidDate, isValidName, is_valid_url_default as isValidUrl, maskedPhoneNumber, parseOtelAttributes, redirect, resolveUrl, sanitizePhoneNumber, snakeToCamelCase, stripCharacters, toDatadogSpanId, toDatadogTraceId };

//# sourceMappingURL=index.mjs.map